import noop from 'utils/noop';

// Implement this for web only
export const useInputFocusFix = (props: {
  setScrollViewHeight: (height: number) => void;
  windowHeight: number;
  scrollViewHeight: number | undefined;
}) => noop;
